import React from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import ProjectCard from "../../components/ProjectCard/ProjectCard";
import { Fade } from "react-reveal";
import { projectsHeader, projects, socialMediaLinks } from "../../portfolio.js";
import "./Projects.css";
import ProjectsImg from "./ProjectsImg";

function Projects(props) {
  const theme = props.theme;

  return (
    <>
      <Header theme={theme} setTheme={props.setTheme} />
      <div className="projects-main main-content">
        <div className="basic-projects">
          <Fade bottom duration={2000} distance="40px">
            <div className="projects-heading-div">
              <div className="projects-heading-img-div">
                <ProjectsImg theme={theme} />
              </div>
              <div className="projects-heading-text-div">
                <h1 className="projects-heading-text">
                  {projectsHeader.title}
                </h1>
                <p
                  className="projects-header-detail-text"
                  style={{ color: theme.secondaryText }}
                >
                  {projectsHeader["description"]}
                </p>
              </div>
            </div>
          </Fade>
        </div>
        <div className="repo-cards-div-main">
          {projects.data.map((repo) => {
            return <ProjectCard key={repo.name} repo={repo} theme={theme} />;
          })}
        </div>
        {socialMediaLinks.github && (
          <div style={{ textAlign: "center", marginTop: "3rem" }}>
            <a
              className="general-btn"
              href={socialMediaLinks.github}
              target="_blank"
              rel="noopener noreferrer"
            >
              More Projects (Github)
            </a>
          </div>
        )}
      </div>
    </>
  );
}

export default Projects;
